import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { InputmaskOptions } from '@ngneat/input-mask';
import { AddressForm } from 'src/app/classes/form-groups/address-form';
import { SubNationalDivision } from 'src/app/classes/models/sub-national-division';
import { LocalizationInfo } from 'src/app/interfaces/localization-info';
import { SubNationalDivisionService } from 'src/app/services/sub-national-division.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddressFormComponent implements OnInit, OnChanges {
  constructor(
    private SubNationalDivisionService: SubNationalDivisionService,
    private ToastService: ToastService,
    private UtilityService: UtilityService,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {}

  @Input() addressForm?: AddressForm;
  @Input() isStreet: boolean = false;
  @Input() isMailing: boolean = false;
  @Input() useMailingAddressTemplate: boolean = false;
  @Input() useStreetAddressTemplate: boolean = false;
  @Input() country?: 'US' | 'CA';

  // This only applies to the default address, not the street/mailing address.
  @Input() defaultLayout: 'horizontal' | 'vertical' = 'vertical';

  SubNationalDivisions: SubNationalDivision[] = [];
  LocalizationInfo!: LocalizationInfo;

  zipMask?: InputmaskOptions<any>;

  requiredFields: Map<string, boolean> = new Map();

  checkForRequiredValidators(formControl: FormControl) {
    return formControl.hasValidator(Validators.required);
  }

  setUpCountryBasedFields() {
    if (!this.country) {
      return;
    }

    this.LocalizationInfo = this.UtilityService.getLocalizedValuesMap(
      this.country
    );
    this.zipMask =
      this.country === 'CA'
        ? this.UtilityService.canadianZipMask
        : this.UtilityService.usZipMask;

    this.SubNationalDivisionService.getSubNationalDivisions({
      country: this.country === 'CA' ? 'Canada' : 'USA'
    }).subscribe({
      next: (data: SubNationalDivision[]) => {
        if (!data) {
          throw this.ToastService.addErrorToast(
            'Error',
            'No SuNationalDivisions found.',
            { returnError: true }
          );
        }

        this.SubNationalDivisions = data;
        this.ChangeDetectorRef.markForCheck();
      }
    });
  }

  ngOnInit(): void {
    this.setUpCountryBasedFields();

    if (this.addressForm) {
      Object.entries(this.addressForm.controls).forEach(([key, control]) => {
        this.requiredFields.set(key, this.checkForRequiredValidators(control));
      });

      if (this.isStreet) {
        this.addressForm.controls.isStreet.patchValue(true);
      }

      if (this.isMailing) {
        this.addressForm.controls.isMailing.patchValue(true);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.setUpCountryBasedFields();
    }
  }
}
